require('./RAGoalDistributionView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const RACover = require('../../components/commons/RACover/RACover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const RAPortfolioDonut = require('../../components/RAPortfolioDonut/RAPortfolioDonut');
const RAAccordionDistributionTable = require('../../components/RAAccordionDistributionTable/RAAccordionDistributionTable');
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');

// @actions
const brokerMyInvestments = require('actions/brokerMyInvestments');
const raObjectiveDetailsActions = require('../../actions/RAObjectiveDetails');

// @constants
const { BROKER_PG_URL } = require('constants/index');
const { MYPROFILE_BROKER_ROBO_URL } = require('../../raConstants/index');
const { ESG_PRODUCT } = require('constants/flagBasedFeatures');

class RAGoalDistributionView extends React.Component {
    constructor(props) {
        super(props);

        this.handleBackClick = this.handleBackClick.bind(this);
    }

    componentDidMount() {
        const {
            immGlobalPosition,
            match: { params: { portfolioId } },
        } = this.props;
        if (!immGlobalPosition.get('hasRoboHired')) {
            this.props.fetchMyInvestments();
        } else {
            this.props.readPortfolioFromGlobalPosition(portfolioId);
        }
    }

    getBreadcrumb() {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: BROKER_PG_URL,
            },
            {
                text: formatText('breadcrumb-breadcrumb_roboLanding'),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: formatText('breadcrumb-breadcrumb_objectiveTracking'),
            },
        ];
    }

    handleBackClick() {
        this.props.history.goBack();
    }

    buildCoverRightContent() {
        return (
            <div className="ra-goal-distribution-view__buttons">
                <div className="ra-goal-distribution-view__buttons--left">
                    <OKButton
                        modifier="ghost"
                        leftIcon="icon-anterior"
                        inverse={true}
                        onClick={this.handleBackClick}
                    >
                        <FormattedText
                            value="buttonsActions-goBack"
                            format="firstUppercase"
                        />
                    </OKButton>
                </div>
            </div>
        );
    }

    render() {
        const {
            immGlobalPosition,
            match: {params: { portfolioId }},
        } = this.props;
        const breadcrumb = this.getBreadcrumb();
        let goalName;
        let goalType;
        let accountInfo;
        let donutContent;
        let tableContent;

        if (immGlobalPosition.get('isFetching')) {
            donutContent = <LoadingSection />;
            tableContent = <LoadingSection />;
        } else if (immGlobalPosition.get('hasRoboHired')) {
            const immPortfolio = immGlobalPosition.getIn([
                'portfolios',
                portfolioId,
            ]);
            const immAssetAllocations = immPortfolio.get('assetAllocation');
            const immRoboAccount = immGlobalPosition.getIn([
                'roboAccount',
                portfolioId,
            ]);
            const immKeyFigures = immPortfolio.get('keyFigures');
            accountInfo = immRoboAccount
                ? immRoboAccount.get('name') +
                  ' ' +
                  getLastNChars(
                      immRoboAccount.getIn(['ibanComplex', 'codbban']),
                  )
                : '';
            goalName = immPortfolio.getIn(['goalInformation', 'name']);
            goalType = immPortfolio.getIn(['goalInformation', 'goalType']);

            donutContent = (
                <RAPortfolioDonut immAssetAllocations={immAssetAllocations} />
            );
            tableContent = (
                <RAAccordionDistributionTable
                    immKeyFigures={immKeyFigures}
                    immAssetAllocations={immAssetAllocations}
                    showRentabilityPercentage={true}
                />
            );
        }
        const coverRightContent = this.buildCoverRightContent();

        return (
            <div className="ra-goal-distribution-view grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            breadcrumb={breadcrumb}
                            section="goal"
                            goalType={goalType}
                            showHelp={false}
                            subtitle={accountInfo}
                            title={goalName}
                            rightContent={coverRightContent}
                            fontSize="34px MarkOT"
                        />
                    </div>
                </div>
                <div className="row ra-goal-distribution-view__container">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="ra-goal-distribution-view__section-chart">
                                        <h3 className="ra-goal-distribution-view__section-title">
                                            <FormattedText value="raGoalDistribution-raGoalDistribution_sectionTitle" />
                                        </h3>
                                        <FormattedText
                                            value="raGoalDistribution-raGoalDistribution_sectionInfo"
                                            className="ra-goal-distribution-view__section-info"
                                        />
                                        {donutContent}
                                    </div>
                                    <FeatureTogglingRender
                                        notAllowedProductKey={ESG_PRODUCT}
                                    >
                                        <div className="ra-goal-distribution-view__section-esg-tag">
                                            <i className="ra-goal-distribution-view__section-esg-icon" />
                                            <FormattedText value="raGoalDistribution-raGoalDistribution_esgTag" />
                                        </div>
                                    </FeatureTogglingRender>
                                    <div className="ra-goal-distribution-view__table-container">
                                        {tableContent}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 ra-goal-distribution-view__footer">
                                    <div className="ra-goal-distribution-view__buttons">
                                        <div className="ra-goal-distribution-view__buttons--right">
                                            <OKButton
                                                onClick={this.handleBackClick}
                                                modifier="ghost"
                                                leftIcon="icon-anterior"
                                            >
                                                <FormattedText
                                                    value="buttonsActions-goBack"
                                                    format="firstUppercase"
                                                />
                                            </OKButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RAGoalDistributionView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    readPortfolioFromGlobalPosition: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immGlobalPosition: state.raGlobalPosition,
        immExpectedProfitability: state.raExpectedProfitability,
    }),
    {
        fetchMyInvestments: brokerMyInvestments.fetchMyInvestments,
        readPortfolioFromGlobalPosition:
            raObjectiveDetailsActions.readPortfolioFromGlobalPosition,
    },
)(withRouter(RAGoalDistributionView));
